import { Outlet } from 'react-router-dom'

/**
 * AuthLayout — minimal pass-through shell for auth pages.
 * Each auth page renders its own <AuthCard> which handles
 * the full-screen background, glassmorphism, and animations.
 */
export function AuthLayout() {
  return <Outlet />
}
